import Swal from "sweetalert2";
export const showSwalAlert = (title, message, icon) => {
  Swal.fire({
    title: title,
    text: message,
    icon: icon,
    position: "top-end",
    timer: 5000,
    showCloseButton: true,
    showConfirmButton: false,
    timerProgressBar: true,
    toast: true,
    customClass: {
      popup: "my-toast",
    },
  });
};
